module.exports = __webpack_public_path__ + "img/student-search-icon.cf5fca6c.svg";